import React from "react";

const WorkHours = props => {
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    const defaultWorkHours = {
        data: days.filter(x => x !== "Sunday" && x !== "Saturday")
        .map(x => days.indexOf(x))
        .reduce((map, obj) => {
            map[obj] = [{ start: "8:00 AM", end: "5:00 PM" }]
            return map;
        }, {}),
        ui : [{day: "weekdays", start: "8:00 AM", end: "5:00 PM"}]
    }


    const [selectedDays, setSelectedDays] = React.useState(props.workHours && props.workHours.ui ? props.workHours : defaultWorkHours);

    React.useEffect(() => {
        if (props.onChange) {
            props.onChange(selectedDays);
        }
    }, []);

    React.useEffect(() => {
        if (props.workHours) {
            if (props.workHours.ui) {
                setSelectedDays(props.workHours);
            } else {
                setSelectedDays(defaultWorkHours);
            }        
        }

        if (props.workHours === null) {
            setSelectedDays(defaultWorkHours);
        }
    }, [props.workHours]);

    const saveSelectedDays = days => {
        days.data = {};
        days.ui.forEach(x => {
            if (!x.day || !x.start || !x.end) return;
            if (x.day === "weekdays") {
                if (!days.data["1"]) days.data["1"] = [];
                days.data["1"].push({start: x.start, end: x.end});
                if (!days.data["2"]) days.data["2"] = [];
                days.data["2"].push({start: x.start, end: x.end});
                if (!days.data["3"]) days.data["3"] = [];
                days.data["3"].push({start: x.start, end: x.end});
                if (!days.data["4"]) days.data["4"] = [];
                days.data["4"].push({start: x.start, end: x.end});
                if (!days.data["5"]) days.data["5"] = [];
                days.data["5"].push({start: x.start, end: x.end});
                return;
            }
            if (x.day === "weekends") {
                if (!days.data["0"]) days.data["0"] = [];
                days.data["0"].push({start: x.start, end: x.end});
                if (!days.data["6"]) days.data["6"] = [];
                days.data["6"].push({start: x.start, end: x.end});
                return;
            }
            if (!days.data[x.day]) days.data[x.day] = [];
            days.data[x.day].push({start: x.start, end: x.end});
        })
        setSelectedDays(days);
        props.onChange(days);
    }

    const onDayChange = (index, e) => {
        let sd = { ...selectedDays };
        sd.ui[index].day = e.target.value;
        saveSelectedDays(sd);
    }

    const onStartChange = (d, index, e) => {
        let sd = { ...selectedDays };
        sd.ui[index].start = e.target.value;
        saveSelectedDays(sd);
    }

    const onEndChange = (d, index, e) => {
        let sd = { ...selectedDays };
        sd.ui[index].end = e.target.value;
        saveSelectedDays(sd);
    }

    const getTimes = (start, end) => {
        let times = [];
        for (let i = 0; i < 24; i+=.5) {
            if (start) {
                let hour = parseInt(start.split(":")[0]);
                if (hour === 12 && start.indexOf("AM") >= 0) hour = 0;
                if (hour !== 12 && start.indexOf("PM") >= 0) hour += 12;
                if (start.indexOf("30") >= 0) hour +=.5;

                if (i <= hour) continue;
            }
            if (end) {
                let hour = parseInt(end.split(":")[0]);
                if (hour === 12 && end.indexOf("AM") >= 0) hour = 0;
                if (hour !== 12 && end.indexOf("PM") >= 0) hour += 12;
                if (end.indexOf("30") >= 0) hour +=.5;

                if (i >= hour) continue;
            }
            let hour = parseInt(i) === 0 ? 12 : parseInt(i) > 12 ? parseInt(i) - 12 : parseInt(i);
            times.push(`${hour}:${i%1 !== 0 ? "30" : "00"} ${i < 12 ? "AM" : "PM"}`);
        }
        return times;
    }

    const add = () => {
        let sd = {...selectedDays};
        sd.ui.push({day: "1", start: "8:00 AM", end: "5:00 PM"});
        saveSelectedDays(sd);
    }

    const removeSchedule = (index) => {
        let sd = { ...selectedDays };
        sd.ui.splice(index, 1);
        saveSelectedDays(sd);
    }

    const validate = wh => {
        //if (wh.)
    }

    return (
        <div className="pf-schedule-work-hours">
            {selectedDays.ui.map((x, i) =>
                <div>
                    <div className="pf-schedule-wh-days pf-schedule-form-group">
                        <select 
                            className="pf-schedule-select"
                            value={x.day}
                            onChange={(e) => onDayChange(i, e)}>
                            <option value="1">Monday</option>
                            <option value="2">Tuesday</option>
                            <option value="3">Wednesday</option>
                            <option value="4">Thursday</option>
                            <option value="5">Friday</option>
                            <option value="6">Saturday</option>
                            <option value="0">Sunday</option>
                            <option value="weekdays">Weekdays</option>
                            <option value="weekends">Weekends</option>
                        </select>
                    </div>
                    <div className="pf-schedule-wh-times pf-schedule-form-group">
                        <div>
                            <label>From</label>
                            <select 
                                className="pf-schedule-select"
                                value={x.start}
                                onChange={(e) => onStartChange(x, i, e)}>
                                {getTimes(null, x.end).map(t => <option key={t} value={t}>{t}</option>)}
                            </select>
                        </div>
                        <div>
                            <label>To</label>
                            <select 
                                className="pf-schedule-select"
                                value={x.end}
                                onChange={(e) => onEndChange(x, i, e)}>
                                {getTimes(x.start, null).map(t => <option key={t} value={t}>{t}</option>)}
                            </select>
                        </div>
                        <div className="pf-schedule-wh-icons">
                            <i onClick={() => removeSchedule(i)} className="far fa-trash-alt" />
                        </div>
                    </div>
                    <hr />
                </div>
            )}

            <div className="pf-schedule-working-hours-add">
                <button className="" type="button" onClick={add}><i className="fas fa-plus" /> Add Time Slot</button>
            </div>
            {/* {
                isDaysError &&
                <div style={styles.error}>Please select some working hours</div>
            } */}
        </div>
    )
}

export default WorkHours;